import React, {Component} from 'react';
//import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import DealerContainer from './DealerContainer';
import OrderbookContainer from './OrderbookContainer';
import TransactionSwitcher from './TransactionSwitcher';
import TotalStats from './TotalStats.js';
import Switcher from '../Charts/Switcher';
import '../../styles/stylesheets/screen.css';
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import * as firebase from 'firebase';
import {Steps} from 'intro.js-react';
import Link from "react-router-dom/es/Link";
import Button from "./Buttons";
import { withStyles } from 'material-ui/styles';
import Drawer from 'material-ui/Drawer';
import List from 'material-ui/List/List';
import ListItem from 'material-ui/List/ListItem';
import ListItemText from 'material-ui/List/ListItemText';
import ExpandLess from 'material-ui-icons/ExpandLess';
import ExpandMore from 'material-ui-icons/ExpandMore';
import Collapse from 'material-ui/transitions/Collapse';
import Paper from 'material-ui/Paper/Paper';
import userStore from '../../stores/UserStore';

let self;
const drawerWidth = "240px";
// const DBwrap = require('../../../../../traderex-backend5/traderex-backend/functions/dbWrap.js');   // didn't work from within frontend (ie. trxprod3/trxprod/...)

const styles = {
  shift: {
    marginLeft: '240px',
    width:'calc(100% - 240px)'
  },
  shiftRight: {
    width:'calc(100% - 240px)'
  },
  shiftBoth: {
    marginLeft: '240px',
    width:'calc(100% - 480px)'
  },
  paper: {
    width: 'auto',
  },
  hide: {
    display: 'inline-block'
  }
};
const style = {
    width: 400,
    margin: 0,
    display: 'inline-block'
};

/**
 * This component acts as the simulationContainer for
 * all components of the simulation receives
 * user prop from app.js
 */
class simulationContainer extends Component {
    constructor(props) {
        console.log("  SimulationContainer constructed.");
        //console.log("  props.dbs[props.location.state.dbi]  is "+JSON.stringify(props.dbs[props.location.state.dbi]) );
        console.log('\n\n');
        super(props);
        this.state = {
            renderplotly: false,
            showingStudents: false,
            studentsData:[],
            open:[],
            isReady: false,
            running: false,
            displayStats: {},
            isSessionAdmin: true,
            showingGodMode: false,
            paused: false,
            pstar: "??"
        };
        this.db = props.dbs[props.location.state.dbi].database().ref(props.institution);
        this.kickUser = this.kickUser.bind(this);
        this.statListeners = [];
        console.log(props);
        setTimeout( ()=>{
          this.getPendingStudentsData();
        }, 1000);
        self = this;
    }

    /**
     * goes to ref StartSim/Ready and
     * sets the state of renderplotly
     */
    componentDidMount() {
        this.canRender = true;
        this.renderLoop = setInterval(()=>{ this.canRender = true; }, 1000);
        console.log("simulationContainer componentDidMount");
        userStore.setGame(this.props.location.state.sessionid);
        this.plotlyrenderRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child('StartSim').child("Ready");
        this.plotlyrenderRef.on('value', snap => {
            if (!!snap.val() && snap.val() === true) {
                this.setState({
                    renderplotly: true
                });
                this.plotlyrenderRef.off();
            } else {
                this.setState({
                    renderplotly: false
                });
            }
        })

        var timeRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("DisplayTime");
        timeRef.on("value", (ss)=>{
          var data = ss.val();
          if (!!data){
            this.props.updateTime(data);
          }
        });
        this.statListeners.push(timeRef);

        var pstarRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("ImportantData/Simulator/pstar");
        pstarRef.on("value", (ss)=>{
          var data = ss.val();
          this.setState({pstar: data});
        });
        this.statListeners.push(pstarRef);

        var pauseRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("pauser");
        pauseRef.on("value", (ss)=>{
          var data = ss.val();
          this.setState({paused: !!data});
        });
        this.statListeners.push(pauseRef);
    }

    toggleStudents(){
      this.setState({showingStudents: !this.state.showingStudents})
      console.log("student");
    }

    toggleControls(){
      this.setState({showingGodMode: !this.state.showingGodMode})
      console.log(`GodMode: ${this.state.showingGodMode}`);
    }

    pauseMe(){
      var pauseRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("pauser");
      pauseRef.set(!this.state.paused);
    }
    pstarDown(){
      console.log("pstar-down")
      let newPstar = parseFloat(this.state.pstar) - .5;
      let pstarRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("ImportantData/Simulator/pstar");
      pstarRef.set(newPstar || "20");
      console.log('i just set it to new pstar  ',newPstar);
      this.setState({pstar: newPstar || "20"});
    }
    pstarUp(){
      console.log("pstar-up")
      let newPstar = parseFloat(this.state.pstar)  + .5;
      let pstarRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("ImportantData/Simulator/pstar");
      pstarRef.set(newPstar || "20");
      this.setState({pstar: newPstar || "20"});
    }
    thinBook(){
      console.log("thin book");
      // set to a large random number;  if it changes, we thinBook() (multiply robot order amounts by half) elsewhere in the code   -Nathan Bendich;  August 1, 2022
      var thinBookClickedRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("lastThinBookClickedNumber").set(Math.floor(Math.random()*1000000000 ));
      /*
      var rand=Math.floor(Math.random()*1000000000 ); // technically we should make absolutely sure this value **__CHANGES__**, but 
      //alert("Thin Book clicked.  rand is "+rand);
      var rand=Math.floor(Math.random()*1000000000 ); // technically we should make absolutely sure this value **__CHANGES__**, but 
      thinBookClickedRef.set(   rand  );
      */
    }
    thickenBook(){
      console.log("thicken");
      var thickenBookClickedRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("lastThickenBookClickedNumber").set(Math.floor(Math.random()*1000000000 ));
    }
    passPoint(newpt){
      /*
      self.setState({
          pstar: newpt.pstar || "20"
      });
      */
      //console.log("why is this here? -")
    }

    registerStats(key){
      let userStatRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").child(key).child("Assets").child("INTC").child("Stats");
      let mRef = userStatRef.child("Mission");
      mRef.on("value", ss=>{
        let data = ss.val();
        if (!!data){
          let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
          displayStats[key].mission = data;
          this.setState({displayStats});
        }
      });
      this.statListeners.push(mRef);
      let sRef = userStatRef.child("Shares");
      sRef.on("value", ss=>{
        let data = ss.val();
        if (!!data){
          let displayStats = Object.assign({}, this.state.displayStats);    //creating copy of stats
          displayStats[key].shares = data;
          this.setState({displayStats});
        }
      });
      this.statListeners.push(sRef);
    }

    getPendingStudentsData() {
        // this.setState({
        //     studentsData:[]
        // })

        this.studentRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("UsersPending");
        //this.userRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").child(this.props.uid).child("INTC").child("stats");
        this.studentRef.on('value', snap =>{
          let rawData = snap.val();
          //console.log("data of student " + rawData);
          let studentInfo;
          let students = [];
          let openstate = [];
          let displayStats = this.state.displayStats;
          for(var key in rawData){
            if (rawData[key].displayName){
                students.push(rawData[key]); //has .uid which == key too
                if (!displayStats.hasOwnProperty(key)){
                  displayStats[key] = {displayName: rawData[key].displayName, mission: "-", shares: "-"};
                  let that = this;
                  let uid = key;
                  setTimeout( ()=>{
                      that.registerStats(uid);
                  }, 0);
                }
            }
          }
          var len = students.length;
          for (var i=0;i<len;i++){
              var flag = false;
              openstate.push(flag);
          }
          this.setState({
              studentsData: students,
              openBuy: openstate,
              displayStats: displayStats
          });
          console.log("student data ", this.state.studentsData);
         // this.state.dataItemsSell = this.state.studentsDataSell.map((numbersSell) =><div>{numbersSell}</div>);
         // this.state.dataItemsBuy = this.state.studentsDataBuy.map((numbersBuy) =><li>{numbersBuy}</li>);
      })
    }

    startTutorial() {
        //console.log("simulationContainer startTutorial");
        this.setState({
            stepsEnabled: true
        })
    }

    handleStart() {
      this.setState({isReady: true});
    }

    handleClickBuy(index) {
        console.log("student clicked", this.state.open);
        var test = this.state.open;
        if(test[index]===false){
            test[index] = true;
        }
        else {
            test[index] = false;
        }
        //test[index] = !test[index];
        this.setState({open: test})

    }

    /**
     * will remove a human dealer from the game
     */

    kickUser(uid, name){
        let userRef = this.db.child("Sessions").child(this.props.location.state.sessionid).child("Users").child(uid).child("didUserLeave");
        userRef.set({ "didUserLeave": true });
        // alert('KICKED ' + uid);
        alert('You have removed ' + name);
    }

    componentWillReceiveProps(nextProps, nextState){
      console.log(nextProps, nextState);
    }

    componentWillUnmount() {
        // console.log("simulationContainer componentWillUnmount");
        this.plotlyrenderRef.off();
        this.studentRef.off();
        this.statListeners.map(theRef=>{
          theRef.off();
        });
        this.props.updateTime(false);
    }

    shouldComponentUpdate(){
      if (this.canRender){
        this.canRender = false;
        return true;
      }
      return false;
    }
    /**
     * renders all components of the simulation here
     * based on renderplotly(bool) conditionally render plotly graph
     */
    render() {
        console.log("simulationContainer render");
        let {stepsEnabled, steps, initialStep} = this.state;
        // alert(this.props.location.state.creator);
        return (
          <div className="app-sim">
                      <Drawer anchor='right' variant="persistent" style={Object.assign({}, !this.state.showingGodMode && styles.hide)} open={this.state.showingGodMode} onClose={this.toggleControls.bind(this)}>
                      <div>
                      <List style={{
                          width:'240px',
                          margin: '0 auto',
                      }} >
                        <ListItem>
                          <button onClick={this.pauseMe.bind(this)}>
                            {this.state.paused && <span>Unpause</span>}
                            {!this.state.paused && <span>Pause</span>}
                          </button>
                        </ListItem>
                        <ListItem>
                          <button onClick={this.thickenBook.bind(this)}>
                            <span>Thicken Book</span>
                          </button>
                        </ListItem>
                        <ListItem>
                          <button onClick={this.thinBook.bind(this)}>
                            <span>Thin Book</span>
                          </button>
                        </ListItem>
                        <ListItem>
                          <h4>Current p*: {this.state.pstar}</h4>
                        </ListItem>
                        <ListItem>
                          <button onClick={this.pstarUp.bind(this)}>
                            <span>Increase p*</span>
                          </button>
                        </ListItem>
                        <ListItem>
                          <button onClick={this.pstarDown.bind(this)}>
                            <span>Decrease p*</span>
                          </button>
                        </ListItem>
                      </List>
                      </div>
                      </Drawer>
            <Drawer variant="persistent" style={Object.assign({}, !this.state.showingStudents && styles.hide)} open={this.state.showingStudents} onClose={this.toggleStudents.bind(this)}>
                {/* <div style={styles.paper}>{this.state.studentsData}</div> */}
                <div>
                <List style={{
                    width:'240px',
                    margin: '0 auto',
                }} >
                    {this.state.studentsData.map((student,index)=>{ return (
                       <ListItem className={(this.props.location.state.dealerMode == true && Math.abs(parseInt(this.state.displayStats[student.uid].shares) )> 500 ? "overLimit" : "underLimit" )} key={student.displayName} button>
                            <ListItemText inset primary={index + 1} />
                            <ListItemText inset primary={student.displayName} />
                            <ListItemText inset primary={this.state.displayStats[student.uid].shares} />
                            {((this.props.location.state.solo || (this.props.user.uid != this.props.location.state.creator)) || !this.props.location.state.dealerMode)
                        ?
                        <div></div>
                        :
                        <button onClick={()=>{this.kickUser(student.uid, student.displayName)}}>x</button>
                    }

                            {!this.props.location.state.dealerMode && <ListItemText inset primary={this.state.displayStats[student.uid].mission} />}
                        </ListItem>
                         );
                    })
                    }
                    </List>
                    {/* <List >
                        <ListItem button onClick={this.handleClickBuy.bind(this)}>
                            <ListItemText inset primary="Buy" />
                            {this.state.openBuy ? <ExpandLess /> : <ExpandMore />}
                        </ListItem>
                        <Collapse in={this.state.openBuy} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItem>
                                <ListItemText inset primary={this.state.dataItemsBuy} />
                                </ListItem>
                            </List>
                        </Collapse>
                        <ListItem button onClick={this.handleClickSell.bind(this)}>
                            <ListItemText inset primary="Sell" />
                            {this.state.openSell ? <ExpandLess /> : <ExpandMore />}
                        </ListItem>
                        <Collapse in={this.state.openSell} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItem>
                                <ListItemText inset primary={this.state.dataItemsSell} />
                                </ListItem>
                            </List>
                        </Collapse>
                    </List> */}
                </div>
            </Drawer>
            <div className="simulation-container-style" style={Object.assign(Object.assign(Object.assign({}, this.state.showingGodMode && styles.shiftRight), this.state.showingStudents && styles.shift), this.state.showingStudents && this.state.showingGodMode && styles.shiftBoth)}>
                <div className="simulation-options-div">
                    <Button
                        uid={this.props.user.uid}
                        institution={this.props.institution}
                        sessionid={this.props.location.state.sessionid}
                        db={this.db}
                        isReady={this.state.isReady}
                        dealerMode={this.props.location.state.dealerMode}
                        toggleControls ={this.toggleControls.bind(this)}
                    />
                    <button onClick={this.toggleStudents.bind(this)} >{this.state.showingStudents ? <span>Hide</span> : <span>Show</span>} Participants </button>
              </div>


                    <div className="total-stats-div-style simulation-box">
                        <TotalStats
                            institution={this.props.institution}
                            sessionid={this.props.location.state.sessionid}
                            db={this.db}
                            uid={this.props.user.uid}
                            dealerMode={this.props.location.state.dealerMode}
                        />
                    </div>
                    <div className="order-book-container-div-style simulation-box">
                       {!!this.props.location.state.dealerMode &&
                          <DealerContainer
                              institution={this.props.institution}
                              sessionid={this.props.location.state.sessionid}
                              db={this.db}
                              uid={this.props.user.uid}
                              onReady={this.handleStart.bind(this)}
                              solo = {this.props.location.state.solo}
                              creator = {this.props.location.state.creator}
                          />
                        }
                        {!this.props.location.state.dealerMode &&
                          <OrderbookContainer
                              institution={this.props.institution}
                              sessionid={this.props.location.state.sessionid}
                              db={this.db}
                              uid={this.props.user.uid}
                              onReady={this.handleStart.bind(this)}
                          />
                        }
                    </div>

                <div className="graph-div simulation-box">
                    {this.state.renderplotly
                        ?
                        <Switcher
                            institution={this.props.institution}
                            db={this.db}
                            sessionid={this.props.location.state.sessionid}
                            passPoint={this.passPoint}
                        />
                        :
                        <div>
                            Loading 3
                            Day Sim...
                        </div>
                    }
                </div>

                <div className="simulation-log simulation-box">
                    <TransactionSwitcher
                        institution={this.props.institution}
                        sessionid={this.props.location.state.sessionid}
                        db={this.db}
                        uid={this.props.user.uid}
                    />
                </div>
            </div>
          </div>
        );
    }
}

simulationContainer.propTypes = {
    authed: PropTypes.bool,
    user: PropTypes.object,
    sessionid: PropTypes.string
};

export default simulationContainer;



// WEBPACK FOOTER //
// ./src/components/Orderbook/SimulationContainer.js